export const LOADING_STATE = "cart/loading";
export const ERROR_STATE = "cart/error";
export const GET_DATA_SUCCESSFULLY = "cart/get/data";
export const REMOVE_ITEM = "cart/delete/item";
export const ADD_ITEM = "cart/add/item";
